import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Image extends Component {
  render () {
    const {
      content
    } = this.props

    return (
      <video controls loop autoPlay width='100%' id='kioskvideo'>
        <source src={content} type='video/mp4' />
        Your browser doesn't support HTML5 video tag.
      </video>
    )
  }
}

Image.propTypes = {
  content: PropTypes.string
}

export default Image



// WEBPACK FOOTER //
// ./src/components/contentDisplay/Video.js